export default class BaseModel {
    constructor()
    {
        this.onChange = new Phaser.Signal();
        this._internalPropertyPrefix = '__$';
    }

    getProperty(name)
    {
        return this[this._internalPropertyPrefix + name];
    }

    setProperty(name, value, silent = false)
    {
        let canonicalPropertyName = this._internalPropertyPrefix + name;
        let oldValue = this[canonicalPropertyName];
        let newValue = value;
        if (oldValue === newValue)
        {
            return;
        }

        this[canonicalPropertyName] = value;

        if (!silent)
        {
            this.onChange.dispatch(this, name, newValue, oldValue);
        }
    }

    compare(model)
    {
        throw new Error('Must be override.');
    }
}
